var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreeBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 18,
    viewBox: "0 0 37 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_404_1794)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 18,
    rx: 9,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02539 13H7.79492V9.67188H11.2344V8.27148H7.79492V6.00391H11.5625V4.54492H6.02539V13ZM12.8773 13H14.5883V9.39062C14.5883 8.47656 15.2035 7.91992 16.1762 7.91992C16.4398 7.91992 16.7035 7.96094 16.9613 8.01953V6.52539C16.7914 6.47852 16.5512 6.44336 16.3227 6.44336C15.4848 6.44336 14.8988 6.85352 14.6937 7.55078H14.5883V6.54883H12.8773V13ZM20.6375 13.1348C22.5242 13.1348 23.3562 12.0449 23.5555 11.2363L23.5672 11.1777H21.9734L21.9559 11.2129C21.8387 11.459 21.4227 11.8574 20.6727 11.8574C19.7645 11.8574 19.1961 11.2422 19.1785 10.1816H23.6199V9.64844C23.6199 7.69727 22.448 6.4082 20.5672 6.4082C18.6863 6.4082 17.4852 7.72656 17.4852 9.77734V9.7832C17.4852 11.8516 18.6746 13.1348 20.6375 13.1348ZM20.5965 7.69141C21.3406 7.69141 21.8738 8.17188 21.9793 9.10938H19.1961C19.3016 8.19531 19.8523 7.69141 20.5965 7.69141ZM27.7062 13.1348C29.593 13.1348 30.425 12.0449 30.6242 11.2363L30.6359 11.1777H29.0422L29.0246 11.2129C28.9074 11.459 28.4914 11.8574 27.7414 11.8574C26.8332 11.8574 26.2648 11.2422 26.2473 10.1816H30.6887V9.64844C30.6887 7.69727 29.5168 6.4082 27.6359 6.4082C25.7551 6.4082 24.5539 7.72656 24.5539 9.77734V9.7832C24.5539 11.8516 25.7434 13.1348 27.7062 13.1348ZM27.6652 7.69141C28.4094 7.69141 28.9426 8.17188 29.048 9.10938H26.2648C26.3703 8.19531 26.9211 7.69141 27.6652 7.69141Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_404_1794",
    x: -5,
    y: -5,
    width: 47,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_404_1794"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_404_1794",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeBadge);
export default __webpack_public_path__ + "static/media/free-badge.908f3b613ca11342004210c38d029afb.svg";
export { ForwardRef as ReactComponent };